module.exports = __webpack_public_path__ + "img/del.6b046ab9.svg";